import { createSelector } from 'reselect';
import { initialState } from './reducer';

export const selectChatsListDomain = state => state.chatsListReducer || initialState;

export const getIsChatsListLoadingSelector = () =>
	createSelector(selectChatsListDomain, ({ isChatsListLoading }) => isChatsListLoading);

export const getChatsListSelector = () => createSelector(selectChatsListDomain, ({ chatsList }) => chatsList);
